import Client from "./client";

export const GetOrganizations = ({accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/organizations', {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.organizations);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateOrganization = ({name, password, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/organizations', {name, password}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.organization);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const JoinOrganization = ({code, password, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/organizations/join', {code, password}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.organization);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const UpdateOrganizationPassword = ({organizationId, password, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/organizations/${organizationId}/password`, {password}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.organization);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// MANAGE_ORG-gated (or the owner), unlike the password above - see
// PUT /organizations/:id/name.
export const RenameOrganization = ({organizationId, name, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/organizations/${organizationId}/name`, {name}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.organization);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const InviteOrganizationMember = ({organizationId, email, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/organizations/${organizationId}/members`, {email}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.member);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const AddProjectToOrganization = ({projectId, organizationId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/organizations`, {organizationId}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const AddProjectToOrganizationByCode = ({projectId, code, password, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/organizations/join`, {code, password}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetProjectOrganizationRequests = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/organization-requests`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.requests);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetProjectOrganizations = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/organizations`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.organizations);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetOrganizationProjects = ({organizationId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/organizations/${organizationId}/projects`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.projects);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetPendingProjectRequests = ({organizationId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/organizations/${organizationId}/pending-projects`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.pending);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const ApproveProjectOrgRequest = ({organizationId, projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/organizations/${organizationId}/pending-projects/${projectId}/approve`, {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const AddProjectUser = ({projectId, email, roleId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/users`, {email, roleId}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const UpdateOrgMemberRole = ({organizationId, memberId, roleId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/organizations/${organizationId}/members/${memberId}/role`, {roleId}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const RemoveOrganizationMember = ({organizationId, memberId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/organizations/${organizationId}/members/${memberId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const TransferOrganizationOwnership = ({organizationId, userId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/organizations/${organizationId}/owner`, {userId}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeleteOrganization = ({organizationId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/organizations/${organizationId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
